import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, ArrowLeft } from 'lucide-react';
import axios from 'axios';
import './TeamLogin.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TeamLogin = () => {
  const [formData, setFormData] = useState({
    employee_id: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const goHome = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API}/auth/login`, formData, {
        withCredentials: true
      });

      if (response.data.success) {
        const { role } = response.data.user;
        
        // Small delay to ensure cookie is set
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Redirect based on role
        if (role === 'admin') {
          window.location.href = '/admin';
        } else {
          window.location.href = '/employee-portal';
        }
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (err) {
      console.error('Login error:', err);
      if (err.response?.status === 401) {
        setError('Invalid Employee ID or password. Please try again.');
      } else if (err.response?.status === 403) {
        setError('Your account has been disabled. Please contact the administrator.');
      } else if (err.code === 'ERR_NETWORK') {
        setError('Network error. Please check your internet connection.');
      } else {
        setError(err.response?.data?.detail || 'Login failed. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="team-login-container">
      <button onClick={goHome} className="btn-back-home" data-testid="back-to-home-btn">
        <ArrowLeft size={20} />
        Back to Homepage
      </button>
      <div className="team-login-card">
        <div className="team-login-header">
          <img 
            src="https://customer-assets.emergentagent.com/job_elegant-royal-bar/artifacts/6ywx5xvf_CFB2E630-E067-4D50-B2DB-A530D292F3D8.png" 
            alt="Royal Bar & Grill" 
            className="team-login-logo clickable-logo"
            onClick={goHome}
            data-testid="login-logo-home-link"
          />
          <h1>Team Member Login</h1>
          <p>Access your employee portal</p>
        </div>

        <form onSubmit={handleSubmit} className="team-login-form">
          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="employee_id">Employee ID</label>
            <input
              type="text"
              id="employee_id"
              name="employee_id"
              value={formData.employee_id}
              onChange={handleChange}
              required
              placeholder="Enter your employee ID"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          <button 
            type="submit" 
            className="btn-login"
            disabled={loading}
          >
            {loading ? 'Logging in...' : (
              <>
                <LogIn size={20} />
                Log In
              </>
            )}
          </button>
        </form>

        <div className="team-login-footer">
          <p>Authorized personnel only</p>
        </div>
      </div>
    </div>
  );
};

export default TeamLogin;
